import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const CHIP_SKELETON_CLASS_NAME = 'ChipSkeleton';
export const CHIP_SKELETON_CLASS_SLOTS = ['root'] as const;

export type ChipSkeletonClassSlot = typeof CHIP_SKELETON_CLASS_SLOTS[number];

export interface ChipSkeletonClasses {
	root: string;
}

export type ChipSkeletonClassKey = keyof ChipSkeletonClasses;

export const getChipSkeletonUtilityClass = (slot: string) =>
	generateUtilityClass(CHIP_SKELETON_CLASS_NAME, slot);

export const chipSkeletonClasses: ChipSkeletonClasses = generateUtilityClasses(
	CHIP_SKELETON_CLASS_NAME,
	['root'],
);

export default chipSkeletonClasses;
